const STORAGE_KEY = 'mailspace_mailbox_access_tokens';

type TokenMap = Record<string, string>;

function readMap(): TokenMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return parsed as TokenMap;
  } catch {
    return {};
  }
}

function writeMap(map: TokenMap) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore
  }
}

export function setMailboxAccessToken(mailboxId: string, token: string) {
  if (!mailboxId || !token) return;
  const map = readMap();
  map[mailboxId] = token;
  writeMap(map);
}

export function getMailboxAccessToken(mailboxId: string): string | null {
  if (!mailboxId) return null;
  const map = readMap();
  return typeof map[mailboxId] === 'string' ? map[mailboxId] : null;
}

export function clearMailboxAccessTokens() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

